module.exports = __webpack_public_path__ + "static/media/cancel.94771a9f.svg";